namespace st.search {
    class FacetItemsController implements controllers.IFacetItemsController {

        group: string = DefaultGroup;
        name: string;
        allowMultiple: boolean = false;
        private model: string | string[];
        private _items: models.FacetItemCollection = new models.FacetItemCollection();

        static $inject = ['$rootScope', 'stFacetService', '$log'];

        constructor(
                $rootScope: angular.IRootScopeService,
                private facetService: services.IFacetService,
                private $log: angular.ILogService) {

            this._items.addWatch(() => {
                this.notify();
            });

            $rootScope.$on('stRegisterFacets', (e: angular.IAngularEvent) => {
                this.facetService.registerFacets(this.group, this.name, this._items);
            });

            $rootScope.$on('stFacetsInit', (e: angular.IAngularEvent, values: { [name: string]: string[] }, groups: string[]) => {
                let selectedNames = values[this.name] || [];
                let changed = this._items.setSelectedNames(selectedNames, false);
                if (changed) {
                    groups.push(this.group);
                }
            });
        }

        get items(): models.IFacetItem[] {
            return this._items;
        }
        set items(value) {
            this._items.length = 0;
            value.forEach((item) => {
               this._items.push(angular.extend(new models.FacetItem(this._items), item));
            });
        }

        modelChanged(): void {
            let ids = this.model ? Array.isArray(this.model) ? <string[]>this.model : [<string>this.model] : [];
            this._items.setSelectedIds(ids);
        }

        toggle(item: models.IFacetItem): void;
        toggle(index: number): void;
        toggle(x): void {
            this._items.toggle(x, this.allowMultiple);
        }

        add(item: models.IFacetItem): void;
        add(index: number): void;
        add(x): void {
            this._items.select(x, this.allowMultiple);
        }

        remove(item: models.IFacetItem): void;
        remove(index: number): void;
        remove(x): void {
            this._items.deselect(x);
        }

        notify() {
            this.facetService.update(this.name, this.group);
        }
    }

    angular.module('st.search')
        .controller('stFacetItemsCtrl', FacetItemsController);
}
